import type { Message } from "@ag-ui/core";
import type { ChatHistoryMessage } from "@/services/chatHistoryService";

/**
 * Maps a slice of BFF chat-history messages into AG-UI Message shapes that
 * CopilotKit v2 can restore via `agent.setMessages()`.
 *
 * Three message shapes are produced (matching @ag-ui/core types exactly):
 *   - role "tool"            → ToolMessage  { id, role, toolCallId, content }
 *   - assistant with toolCalls → AssistantMessage { id, role, content, toolCalls }
 *   - otherwise              → UserMessage / plain AssistantMessage { id, role, content }
 *
 * Field names use camelCase throughout — backend emits camelCase and @ag-ui/core
 * expects camelCase (`toolCallId`, `toolCalls`); no conversion needed.
 */
export function mapHistoryToAgentMessages(history: ChatHistoryMessage[]): Message[] {
  return history.map((m): Message => {
    if (m.role === "tool") {
      return {
        id: m.pid,
        role: "tool",
        toolCallId: m.toolCallId ?? "",
        content: m.content,
      };
    }

    if (m.role === "assistant" && m.toolCalls && m.toolCalls.length > 0) {
      return {
        id: m.pid,
        role: "assistant",
        content: m.content,
        toolCalls: m.toolCalls,
      };
    }

    return {
      id: m.pid,
      role: m.role as "user" | "assistant",
      content: m.content,
    };
  });
}
